import * as ambassadorWixPricingPlansV2Order from './pricing-plans-v2-order-orders.http.js';
import * as ambassadorWixPricingPlansV2OrderTypes from './pricing-plans-v2-order-orders.types.js';
import * as ambassadorWixPricingPlansV2OrderUniversalTypes from './pricing-plans-v2-order-orders.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function managementGetOrder(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixPricingPlansV2OrderUniversalTypes.GetOrderRequest,
  ambassadorWixPricingPlansV2OrderTypes.GetOrderRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.GetOrderResponse,
  ambassadorWixPricingPlansV2OrderTypes.GetOrderResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.managementGetOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/orders/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function managementListOrders(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPricingPlansV2OrderUniversalTypes.ListOrdersRequest,
  ambassadorWixPricingPlansV2OrderTypes.ListOrdersRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.ListOrdersResponse,
  ambassadorWixPricingPlansV2OrderTypes.ListOrdersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.managementListOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/orders',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function postponeEndDate(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string },
  ambassadorWixPricingPlansV2OrderUniversalTypes.PostponeEndDateRequest,
  ambassadorWixPricingPlansV2OrderTypes.PostponeEndDateRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.PostponeEndDateResponse,
  ambassadorWixPricingPlansV2OrderTypes.PostponeEndDateResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.postponeEndDate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/orders/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelOrder(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixPricingPlansV2OrderUniversalTypes.CancelOrderRequest,
  ambassadorWixPricingPlansV2OrderTypes.CancelOrderRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.CancelOrderResponse,
  ambassadorWixPricingPlansV2OrderTypes.CancelOrderResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.cancelOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/orders/{id}/cancel',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function markAsPaid(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixPricingPlansV2OrderUniversalTypes.MarkAsPaidRequest,
  ambassadorWixPricingPlansV2OrderTypes.MarkAsPaidRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.MarkAsPaidResponse,
  ambassadorWixPricingPlansV2OrderTypes.MarkAsPaidResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.markAsPaid(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/orders/{id}/mark-as-paid',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function pauseOrder(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixPricingPlansV2OrderUniversalTypes.PauseOrderRequest,
  ambassadorWixPricingPlansV2OrderTypes.PauseOrderRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.PauseOrderResponse,
  ambassadorWixPricingPlansV2OrderTypes.PauseOrderResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.pauseOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/orders/{id}/pause',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function resumeOrder(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixPricingPlansV2OrderUniversalTypes.ResumeOrderRequest,
  ambassadorWixPricingPlansV2OrderTypes.ResumeOrderRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.ResumeOrderResponse,
  ambassadorWixPricingPlansV2OrderTypes.ResumeOrderResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.resumeOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/orders/{id}/resume',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createOnlineOrder(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPricingPlansV2OrderUniversalTypes.CreateOnlineOrderRequest,
  ambassadorWixPricingPlansV2OrderTypes.CreateOnlineOrderRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.CreateOnlineOrderResponse,
  ambassadorWixPricingPlansV2OrderTypes.CreateOnlineOrderResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.createOnlineOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/checkout/orders/online',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createOfflineOrder(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPricingPlansV2OrderUniversalTypes.CreateOfflineOrderRequest,
  ambassadorWixPricingPlansV2OrderTypes.CreateOfflineOrderRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.CreateOfflineOrderResponse,
  ambassadorWixPricingPlansV2OrderTypes.CreateOfflineOrderResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.createOfflineOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/checkout/orders/offline',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getOnlineOrderPreview(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPricingPlansV2OrderUniversalTypes.GetOnlineOrderPreviewRequest,
  ambassadorWixPricingPlansV2OrderTypes.GetOnlineOrderPreviewRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.GetOnlineOrderPreviewResponse,
  ambassadorWixPricingPlansV2OrderTypes.GetOnlineOrderPreviewResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.getOnlineOrderPreview(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/checkout/orders/preview-online',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getOfflineOrderPreview(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPricingPlansV2OrderUniversalTypes.GetOfflineOrderPreviewRequest,
  ambassadorWixPricingPlansV2OrderTypes.GetOfflineOrderPreviewRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.GetOfflineOrderPreviewResponse,
  ambassadorWixPricingPlansV2OrderTypes.GetOfflineOrderPreviewResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.getOfflineOrderPreview(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/checkout/orders/preview-offline',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPricePreview(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPricingPlansV2OrderUniversalTypes.GetPricePreviewRequest,
  ambassadorWixPricingPlansV2OrderTypes.GetPricePreviewRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.GetPricePreviewResponse,
  ambassadorWixPricingPlansV2OrderTypes.GetPricePreviewResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.getPricePreview(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/checkout/orders/price-preview',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function memberGetOrder(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixPricingPlansV2OrderUniversalTypes.MemberGetOrderRequest,
  ambassadorWixPricingPlansV2OrderTypes.MemberGetOrderRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.MemberGetOrderResponse,
  ambassadorWixPricingPlansV2OrderTypes.MemberGetOrderResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.memberGetOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/member/orders/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function memberListOrders(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPricingPlansV2OrderUniversalTypes.MemberListOrdersRequest,
  ambassadorWixPricingPlansV2OrderTypes.MemberListOrdersRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.MemberListOrdersResponse,
  ambassadorWixPricingPlansV2OrderTypes.MemberListOrdersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.memberListOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/member/orders',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function requestCancellation(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixPricingPlansV2OrderUniversalTypes.RequestCancellationRequest,
  ambassadorWixPricingPlansV2OrderTypes.RequestCancellationRequest,
  ambassadorWixPricingPlansV2OrderUniversalTypes.RequestCancellationResponse,
  ambassadorWixPricingPlansV2OrderTypes.RequestCancellationResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixPricingPlansV2Order.requestCancellation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/member/orders/{id}/cancel',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Order as OrderOriginal,
  Buyer as BuyerOriginal,
  PriceDetails as PriceDetailsOriginal,
  PriceDetailsPricingModelOneOf as PriceDetailsPricingModelOneOfOriginal,
  Tax as TaxOriginal,
  Recurrence as RecurrenceOriginal,
  Duration as DurationOriginal,
  PeriodUnit as PeriodUnitOriginal,
  PeriodUnitWithLiterals as PeriodUnitWithLiteralsOriginal,
  Coupon as CouponOriginal,
  PricingDetails as PricingDetailsOriginal,
  PricingDetailsPricingModelOneOf as PricingDetailsPricingModelOneOfOriginal,
  SpannedPrice as SpannedPriceOriginal,
  PriceDuration as PriceDurationOriginal,
  Price as PriceOriginal,
  Fee as FeeOriginal,
  OrderType as OrderTypeOriginal,
  OrderTypeWithLiterals as OrderTypeWithLiteralsOriginal,
  OrderMethod as OrderMethodOriginal,
  OrderMethodWithLiterals as OrderMethodWithLiteralsOriginal,
  OrderStatus as OrderStatusOriginal,
  OrderStatusWithLiterals as OrderStatusWithLiteralsOriginal,
  Cancellation as CancellationOriginal,
  CancellationCause as CancellationCauseOriginal,
  CancellationCauseWithLiterals as CancellationCauseWithLiteralsOriginal,
  CancellationEffectiveAt as CancellationEffectiveAtOriginal,
  CancellationEffectiveAtWithLiterals as CancellationEffectiveAtWithLiteralsOriginal,
  PaymentStatus as PaymentStatusOriginal,
  PaymentStatusWithLiterals as PaymentStatusWithLiteralsOriginal,
  PausePeriod as PausePeriodOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  CurrentCycle as CurrentCycleOriginal,
  OrderCycle as OrderCycleOriginal,
  FormData as FormDataOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  OrderPurchased as OrderPurchasedOriginal,
  OrderStarted as OrderStartedOriginal,
  OrderCycleStarted as OrderCycleStartedOriginal,
  OrderAutoRenewCanceled as OrderAutoRenewCanceledOriginal,
  OrderEnded as OrderEndedOriginal,
  GetOrderRequest as GetOrderRequestOriginal,
  Set as SetOriginal,
  SetWithLiterals as SetWithLiteralsOriginal,
  GetOrderResponse as GetOrderResponseOriginal,
  ListOrdersRequest as ListOrdersRequestOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  ListOrdersResponse as ListOrdersResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  OrdersQueryOrdersRequest as OrdersQueryOrdersRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  OrdersQueryOrdersResponse as OrdersQueryOrdersResponseOriginal,
  GetOrdersStatsRequest as GetOrdersStatsRequestOriginal,
  GetOrdersStatsResponse as GetOrdersStatsResponseOriginal,
  GetAvailableOrderActionsRequest as GetAvailableOrderActionsRequestOriginal,
  GetAvailableOrderActionsResponse as GetAvailableOrderActionsResponseOriginal,
  ReasonNotSuspendable as ReasonNotSuspendableOriginal,
  ReasonNotSuspendableWithLiterals as ReasonNotSuspendableWithLiteralsOriginal,
  PostponeEndDateRequest as PostponeEndDateRequestOriginal,
  PostponeEndDateResponse as PostponeEndDateResponseOriginal,
  OrderEndDatePostponed as OrderEndDatePostponedOriginal,
  CancelOrderRequest as CancelOrderRequestOriginal,
  CancelOrderResponse as CancelOrderResponseOriginal,
  OrderCanceled as OrderCanceledOriginal,
  MarkAsPaidRequest as MarkAsPaidRequestOriginal,
  MarkAsPaidResponse as MarkAsPaidResponseOriginal,
  OrderMarkedAsPaid as OrderMarkedAsPaidOriginal,
  PauseOrderRequest as PauseOrderRequestOriginal,
  PauseOrderResponse as PauseOrderResponseOriginal,
  OrderPaused as OrderPausedOriginal,
  BulkPauseOrderRequest as BulkPauseOrderRequestOriginal,
  BulkPauseOrderResponse as BulkPauseOrderResponseOriginal,
  BulkOrderResult as BulkOrderResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  ResumeOrderRequest as ResumeOrderRequestOriginal,
  ResumeOrderResponse as ResumeOrderResponseOriginal,
  OrderResumed as OrderResumedOriginal,
  BulkResumeOrderRequest as BulkResumeOrderRequestOriginal,
  BulkResumeOrderResponse as BulkResumeOrderResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateOnlineOrderRequest as CreateOnlineOrderRequestOriginal,
  OnBehalf as OnBehalfOriginal,
  CreateOnlineOrderResponse as CreateOnlineOrderResponseOriginal,
  CouponsError as CouponsErrorOriginal,
  CreateGuestOnlineOrderRequest as CreateGuestOnlineOrderRequestOriginal,
  Captcha as CaptchaOriginal,
  Guest as GuestOriginal,
  CreateGuestOnlineOrderResponse as CreateGuestOnlineOrderResponseOriginal,
  CreateOfflineOrderRequest as CreateOfflineOrderRequestOriginal,
  CreateOfflineOrderResponse as CreateOfflineOrderResponseOriginal,
  CreateExternalOrderRequest as CreateExternalOrderRequestOriginal,
  CreateExternalOrderResponse as CreateExternalOrderResponseOriginal,
  GetOnlineOrderPreviewRequest as GetOnlineOrderPreviewRequestOriginal,
  GetOnlineOrderPreviewResponse as GetOnlineOrderPreviewResponseOriginal,
  GetGuestOnlineOrderPreviewRequest as GetGuestOnlineOrderPreviewRequestOriginal,
  GetGuestOnlineOrderPreviewResponse as GetGuestOnlineOrderPreviewResponseOriginal,
  GetOfflineOrderPreviewRequest as GetOfflineOrderPreviewRequestOriginal,
  GetOfflineOrderPreviewResponse as GetOfflineOrderPreviewResponseOriginal,
  GetPricePreviewRequest as GetPricePreviewRequestOriginal,
  GetPricePreviewResponse as GetPricePreviewResponseOriginal,
  ChangeStartDateRequest as ChangeStartDateRequestOriginal,
  ChangeStartDateResponse as ChangeStartDateResponseOriginal,
  OrderStartDateChanged as OrderStartDateChangedOriginal,
  ApplyCouponRequest as ApplyCouponRequestOriginal,
  ApplyCouponResponse as ApplyCouponResponseOriginal,
  SetSubmissionRequest as SetSubmissionRequestOriginal,
  SetSubmissionResponse as SetSubmissionResponseOriginal,
  MemberGetOrderRequest as MemberGetOrderRequestOriginal,
  MemberGetOrderResponse as MemberGetOrderResponseOriginal,
  MemberListOrdersRequest as MemberListOrdersRequestOriginal,
  MemberListOrdersResponse as MemberListOrdersResponseOriginal,
  QueryOrdersRequest as QueryOrdersRequestOriginal,
  QueryOrdersResponse as QueryOrdersResponseOriginal,
  RequestCancellationRequest as RequestCancellationRequestOriginal,
  RequestCancellationResponse as RequestCancellationResponseOriginal,
  CreateOnlineOrderApplicationErrors as CreateOnlineOrderApplicationErrorsOriginal,
  CreateOnlineOrderValidationErrors as CreateOnlineOrderValidationErrorsOriginal,
  CreateOfflineOrderApplicationErrors as CreateOfflineOrderApplicationErrorsOriginal,
  CreateOfflineOrderValidationErrors as CreateOfflineOrderValidationErrorsOriginal,
  GetOnlineOrderPreviewApplicationErrors as GetOnlineOrderPreviewApplicationErrorsOriginal,
  GetOnlineOrderPreviewValidationErrors as GetOnlineOrderPreviewValidationErrorsOriginal,
  GetOfflineOrderPreviewApplicationErrors as GetOfflineOrderPreviewApplicationErrorsOriginal,
  GetOfflineOrderPreviewValidationErrors as GetOfflineOrderPreviewValidationErrorsOriginal,
  GetPricePreviewApplicationErrors as GetPricePreviewApplicationErrorsOriginal,
} from './pricing-plans-v2-order-orders.types.js';
